<template>
  <div class="p-4 text-white" style="min-height: 90vh">
    <el-form :model="form">
      <el-form-item label="版本">
        <el-radio-group v-model="form.version" @change="getData">
          <el-radio label="">全版本</el-radio>
          <el-radio
            v-for="item in skin_versions"
            :label="item"
            :key="item"
            >{{ item }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="测试时间">
        <el-date-picker
          v-model="form.testTime"
          size="mini"
          type="daterange"
          class="dist-picker"
          range-separator="To"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="YYYY-MM-DD"
          @change="getData"
        />
      </el-form-item>
    </el-form>

    <el-table :data="staticsTableData" class="my-4 my-table-hok table-statics" style="width: 1400px"
      :header-cell-style="{
        background: '#42484E',
        color: '#fff',
      }">
      <el-table-column width="100" prop="model" label="机型">
      </el-table-column>
      <el-table-column width="100" prop="inside_skin_num" label="局内测试皮肤数">
      </el-table-column>
      <el-table-column width="100" prop="inside_skin_pass_num" label="局内通过皮肤数">
      </el-table-column>
      <el-table-column width="100" prop="skin_num" label="局外测试皮肤数">
      </el-table-column>
      <el-table-column width="100" prop="skin_pass_num" label="局外通过皮肤数">
      </el-table-column>
      <el-table-column width="160" prop="inside_skin_num2" label="局内测试皮肤数（不去重）">
      </el-table-column>
      <el-table-column width="160" prop="inside_skin_pass_num2" label="局内通过皮肤数（不去重）">
      </el-table-column>
      <el-table-column width="160" prop="skin_num2" label="局外测试皮肤数（不去重）">
      </el-table-column>
      <el-table-column width="160" prop="skin_pass_num2" label="局外通过皮肤数（不去重）">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {ref, computed} from 'vue'
import axios from 'axios'
import {startOfMonth, format} from 'date-fns'

export default {
  setup() {
    const staticsTableData = ref([]),
      form = ref({
        version: '',
        testTime: [format(startOfMonth(new Date), 'yyyy-MM-dd'), format(new Date, 'yyyy-MM-dd')]
      }),
      skin_versions = ref([]),
      project = 57
    let num = 0

    async function getStaticsData() {
      const {version, testTime} = form.value,
        {data} = await axios('report/all_skin_num/', {
          params: {
            project,
            version,
            start_date: testTime[0],
            end_date: testTime[1]
          }
        })

      staticsTableData.value = Object.keys(data).map(model => {
        const value = data[model]

        return {
          model,
          ...value,
        }
      })
    }

    async function getNoRepeatData() {
      const {version, testTime} = form.value,
        {data} = await axios(`report/all_skin_num_v1/`, {
          params: {
            project,
            version,
            start_date: testTime[0],
            end_date: testTime[1]
          }
        })
      
      Object.keys(data).forEach(model => {
        const row = staticsTableData.value.find(item => item.model == model)
        const {inside_skin_num, inside_skin_pass_num, skin_num, skin_pass_num} = data[model]
        
        row.inside_skin_num2 = inside_skin_num
        row.inside_skin_pass_num2 = inside_skin_pass_num
        row.skin_num2 = skin_num
        row.skin_pass_num2 = skin_pass_num
      })
    }

    async function getData() {
      await getStaticsData()
      getNoRepeatData()
    }

    async function handleClickTab() {
      num++
      if (num == 1) {
        getData()
      }
    }

    async function getVersions() {
      const {data} = await axios(`report/skin_versions/?project=${project}`)
      skin_versions.value = data.version_list
    }

    getVersions()

    return {skin_versions, form, staticsTableData, getStaticsData, handleClickTab, getData}
  }
}
</script>

<style scoped>
.el-form-item :deep(.el-form-item__label),
.el-form-item :deep(.el-radio__label) {
  color: #fff;
}

.el-form-item :deep(.el-range-separator) {
  width: 10%;
}


.my-table-hok {
  font-size: 13px;
}

.my-table-hok :deep(.el-table__row) {
  background: #42484e;
  color: #fff;
}

.my-table-hok.el-table :deep(.el-table__row:hover td) {
  background-color: inherit;
  color: #4ed8da;
}

.my-table-hok :deep(.el-table__empty-block) {
  background: #2d3136;
  color: #fff;
}

.my-table-hok :deep(.is-leaf) {
  border-bottom: 1px solid rgb(71, 72, 106) !important;
}

.my-table-hok :deep(td) {
  border-bottom: 1px solid rgb(71, 72, 106) !important;
}

.my-table-hok::before {
  height: 0px;
}
</style>